import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText, Clock, CheckCircle, AlertTriangle, Download, Shield } from 'lucide-react';
import { getText, getCurrentLanguage } from '../../services/dataSync';

const MPCBServicePage = () => {
  const [currentLang, setCurrentLang] = useState(getCurrentLanguage());

  useEffect(() => {
    const handleLanguageChange = () => {
      setCurrentLang(getCurrentLanguage());
    };

    window.addEventListener('languageChanged', handleLanguageChange);
    window.addEventListener('storage', handleLanguageChange);

    return () => {
      window.removeEventListener('languageChanged', handleLanguageChange);
      window.removeEventListener('storage', handleLanguageChange);
    };
  }, []);

  const serviceInfo = {
    name: 'MPCB / CPCB (प्रदूषण नियंत्रण मंडळ)',
    description: 'Environmental compliance and pollution control guidance for industries',
    processingTime: '15-30 days',
    successRate: '95%',
    experience: '10+ years'
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="hero hero-support relative overflow-hidden">
        <div className="container text-center relative z-10">
          <div className="flex justify-center mb-6">
            <div className="bg-primary-gradient rounded-2xl w-20 h-20 flex items-center justify-center shadow-lg">
              <Shield className="h-10 w-10 text-white" />
            </div>
          </div>
          <h1 className="hero-title">{serviceInfo.name}</h1>
          <p className="hero-subtitle">{serviceInfo.description}</p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <div className="bg-white bg-opacity-10 text-white px-4 py-2 rounded-full flex items-center">
              <Clock className="h-5 w-5 mr-2" />
              <span>Processing: {serviceInfo.processingTime}</span>
            </div>
            <div className="bg-white bg-opacity-10 text-white px-4 py-2 rounded-full flex items-center">
              <CheckCircle className="h-5 w-5 mr-2" />
              <span>Success Rate: {serviceInfo.successRate}</span>
            </div>
            <div className="bg-white bg-opacity-10 text-white px-4 py-2 rounded-full flex items-center">
              <FileText className="h-5 w-5 mr-2" />
              <span>Experience: {serviceInfo.experience}</span>
            </div>
          </div>
        </div>
      </section>

      {/* Service Details */}
      <section className="section">
        <div className="container">
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h2 className="text-2xl font-bold mb-4">Service Overview</h2>
              <p className="text-gray-600 mb-6">
                Comprehensive support for environmental compliance and pollution control requirements. 
                We help industries navigate complex MPCB and CPCB regulations with expert guidance.
              </p>
              
              <h3 className="text-xl font-semibold mb-3">Key Services</h3>
              <ul className="space-y-2">
                <li className="flex items-center">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" />
                  Consent to Establish/Operate applications
                </li>
                <li className="flex items-center">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" />
                  Environmental compliance reports
                </li>
                <li className="flex items-center">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" />
                  Hazardous waste management guidance
                </li>
                <li className="flex items-center">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" />
                  Air and water pollution control
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4">Why Choose Us</h2>
              <div className="space-y-4">
                <div className="bg-white p-4 rounded-lg shadow">
                  <h4 className="font-semibold mb-2">Expert Team</h4>
                  <p className="text-gray-600">Certified environmental consultants with deep regulatory knowledge</p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow">
                  <h4 className="font-semibold mb-2">Fast Processing</h4>
                  <p className="text-gray-600">Streamlined procedures for quick approval and compliance</p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow">
                  <h4 className="font-semibold mb-2">End-to-End Support</h4>
                  <p className="text-gray-600">Complete assistance from application to approval</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default MPCBServicePage;
